<template>
  <div class="video-thumb">
    <v-img
      :src="video && video.thumbUrl ? video.thumbUrl : srcThumb"
      class="pointer"
      :height="sizeHeight ? sizeHeight : '180px'"
      @click="openVideoPage()"
    >
      <div class="d-flex align-center justify-center fill-height">
        <div class="buttons">
          <v-btn color="rgba(255,255,255,.6)" fab icon>
            <v-icon size="73">fal fa-circle-play</v-icon>
          </v-btn>
        </div>
      </div>
    </v-img>
    <v-row no-gutters class="absoluteViewChannel">
        <v-col cols="12">
          <div class="d-flex avatarBox pa-2">
            <AvatarComponent
              size="38"
              :url="meta.channelLogo"
            />
            <div class="boxedContent mx-3">
              <h5 class="video-thumb__title">
                <strong>
                  <div @click="gotoChannel" class="white--text">
                    {{ meta.channelName }}
                  </div>
                </strong>
              </h5>

              <p class="video-thumb__stat white--text caption">
                <span>{{
                  `${nFormatter(meta.channelSubscriber) || 0} ${$gettext("subscribers")}`
                }}</span>
              </p>

              <p class="video-thumb__stat white--text caption">
                <span>{{
                  `${parseInt(meta.view).toLocaleString() || 0} ${$gettext(
                    "views"
                  )}`
                }}</span>
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import ButtonLike from "@/components/Buttons/ButtonLike";
export default {
  props: {
    srcThumb: String,
    sizeHeight: String,
    vlog: Object,
    video: Object,
    notAvatar: {
      type: Boolean,
      default: false
    },
    meta: {
      type: Object,
      default: {}
    }
  },
  components: {
    ButtonLike,
  },
  data() {
    return {};
  },

  methods: {
    openVideoPage() {
      this.$emit("openDialogDetail", this.vlog || null);
    },
    gotoChannel() {
      window.open(`https://www.youtube.com/channel/${this.meta.channelId}`, '_blank');
    },
    nFormatter(num) {
      num = parseInt(num);
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
      }
      return num;
    }
  },
};
</script>
<style lang="scss">
.absoluteViewChannel {
  background: rgba(34, 34, 34, 0.75);
  position: absolute;
  width: 100%;
  bottom: 0;
}
</style>